import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function loginvalidateInputs(data){    
    let errors = {};     
    
    if(Validator.isEmpty(data.email)){       
        errors.email ="This field cannot be null";           
    } 

    if(!Validator.isEmail(data.email)){       
        errors.email ="Please enter a valid email";           
    } 
    if(Validator.isEmpty(data.password)){       
        errors.password ="This field cannot be null";           
    } 
    
      
    return {
        errors,
        isValid:isEmpty(errors)
    };
}